<!-- 批次管理 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button
                    class="theme-bg mb-24"
                    icon="md-add-circle"
                    type="warning"
                    @click="goModal(1)"
                    >新增批次</Button
                >
                <Table
                    ref="selection"
                    :columns="columnsTable"
                    :data="dataTable"
                    border
                    @on-selection-change="changeSelection"
                >
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="is_voice">
                        <div class="flex-c">
                            <i-switch
                                v-model="row.is_voice"
                                size="large"
                                true-color="#FF761D"
                                :true-value="1"
                                :false-value="2"
                                @on-change="changeIsVoice(row, $event)"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button
                                type="success"
                                ghost
                                label="small"
                                @click="goMyCode(row)"
                                >预览溯源码</Button
                            >
                            <Button
                                type="primary"
                                ghost
                                label="small"
                                @click="goModal(1, row)"
                                >编辑</Button
                            >
                            <Button
                                type="error"
                                ghost
                                label="small"
                                @click="goDel(1, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox
                        class="checkbox-ml"
                        v-model="del_value"
                        @on-change="handleSelectAll"
                        >全选</Checkbox
                    >
                    <span class="mr-24 ml-24"
                        >已经选择{{ delData.length }}个</span
                    >
                    <Button type="error" ghost label="large" @click="goDel(0)"
                        >删除</Button
                    >
                </div>
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增或修改批次 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            :width="modalWidth"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formData"
                    label-position="right"
                    :label-width="160"
                >
                    <FormItem label="批次名称：">
                        <Input
                            class="w200"
                            type="text"
                            v-model="formData.batch_name"
                            placeholder="请输入批次名称"
                        ></Input>
                    </FormItem>
                    <FormItem label="语音播报：">
                        <i-switch
                            v-model="formData.is_voice"
                            size="large"
                            true-color="#FF761D"
                            :true-value="1"
                            :false-value="2"
                        >
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </FormItem>
                    <FormItem label="最大查询数：">
                        <Input
                            class="w200"
                            type="number"
                            v-model="formData.max_query"
                            placeholder="请输入最大查询数"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml-24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D"
                            />
                            <div slot="content"><p>0则不限制查询次数</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="是否强制关注服务号：">
                        <i-switch
                            v-model="formData.is_follow_wechat"
                            size="large"
                            true-color="#FF761D"
                            :true-value="1"
                            :false-value="0"
                        >
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml-24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D"
                            />
                            <div slot="content">
                                <p>需检查系统设置内公众号是否配置</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="选择模板：">
                        <Button @click="goModal(2, formData)">
                            <span v-if="formData.template_id">{{
                                itemData.template_title
                                    ? itemData.template_title
                                    : "选择模板"
                            }}</span>
                            <span v-else>选择模板</span>
                        </Button>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml-24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D"
                            />
                            <div slot="content">
                                <p>
                                    选择模板后，该批次的溯源码将优先使用此模板
                                </p>
                            </div>
                        </Tooltip>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bg" type="warning" @click="submitModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 选择模板 -->
        <Modal
            v-model="template_modal"
            title=" "
            width="60"
            :mask-closable="false"
        >
            <div>
                <Menu
                    mode="horizontal"
                    :active-name="formData.template_type"
                    @on-select="selectTemplate"
                >
                    <MenuItem name="1">产品模板</MenuItem>
                    <MenuItem name="2">DIY模版</MenuItem>
                </Menu>
                <Table
                    class="mt-24"
                    :columns="columnsTemplate"
                    :data="dataTemplate"
                    border
                >
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <div class="width_54">
                                <div
                                    class="t-color"
                                    v-if="formData.template_id == row.id"
                                >
                                    使用中
                                </div>
                                <Button
                                    v-else
                                    type="warning"
                                    ghost
                                    label="small"
                                    @click="useTemplate(row)"
                                    >使用</Button
                                >
                            </div>
                        </div>
                    </template>
                </Table>
                <div class="page_div">
                    <Page
                        :current="storeTemplate.page"
                        :page-size="storeTemplate.limit"
                        :total="totalTemplate"
                        show-elevator
                        show-total
                        @on-change="pageChangeTemplate"
                    />
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- myCode -->
        <Drawer
            v-model="is_code"
            :title="drawerTitle"
            width="80"
            :transfer="false"
        >
            <myCode></myCode>
        </Drawer>
    </div>
</template>

<script>
import {
    batch_list,
    batch_delete,
    batch_info,
    template_result_template,
    template_diy_list,
    batch_save,
    batch_change,
} from "@/api/index";
import myCode from "@/components/myCode/myCode.vue";
export default {
    components: { myCode },
    data() {
        return {
            drawerTitle: "",
            itemData: {
                template_title: "",
                report_imgs: [],
                show_report_imgs: [],
            },
            is_code: false,
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "selection", width: 60, align: "center" },
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "批次ID", key: "id", align: "center" },
                { title: "批次名称", key: "batch_name", align: "center" },
                { title: "最大查询数", key: "max_query", align: "center" },
                { title: "语音播报", slot: "is_voice", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "300px",
                },
            ],
            dataTable: [],
            modals: false,
            template_modal: false,
            modalTitle: "",
            modalWidth: "",
            formData: {
                id: "",
                batch_name: "",
                is_voice: 2,
                max_query: "",
                template_type: "1",
                template_id: "",
                is_follow_wechat: 0,
            },
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            infoId: "",
            storeTemplate: {
                page: 1,
                limit: 10,
                industry_id: -1,
            },
            totalTemplate: 0,
            columnsTemplate: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "ID", key: "id", align: "center" },
                { title: "模板名称", key: "title", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataTemplate: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            batch_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        pageChangeTemplate(index) {
            this.storeTemplate.page = index;
            if (this.formData.template_type == 1) {
                this.getTemplateList();
            } else if (this.formData.template_type == 2) {
                this.getDiyList();
            }
        },
        changeIsVoice(row, e) {
            let that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变语音播报状态吗？",
                onOk: () => {
                    batch_change({ id: row.id })
                        .then((res) => {
                            that.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {
                    that.getList();
                },
            });
        },
        // 详情
        getInfo() {
            batch_info({ id: this.infoId })
                .then((res) => {
                    this.formData.id = res.data.id;
                    this.formData.batch_name = res.data.batch_name;
                    this.formData.is_voice = res.data.is_voice;
                    this.formData.max_query = res.data.max_query;
                    this.formData.template_type = res.data.template_type + "";
                    this.formData.template_id = res.data.template_id;
                    this.formData.is_follow_wechat = res.data.is_follow_wechat;
                    this.itemData.template_title = res.data.template.title;
                    if (res.data.report_imgs) {
                        var report_imgs = res.data.report_imgs;
                        this.itemData.report_imgs = report_imgs.split(",");
                    }
                    this.itemData.show_report_imgs = res.data.show_report_imgs;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 模板列表
        getTemplateList() {
            template_result_template(this.storeTemplate)
                .then((res) => {
                    this.dataTemplate = res.data.data;
                    this.totalTemplate = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getDiyList() {
            template_diy_list(this.storeTemplate)
                .then((res) => {
                    this.dataTemplate = res.data.data;
                    this.totalTemplate = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        selectTemplate(name) {
            this.formData.template_type = name;
            if (name == 1) {
                this.getTemplateList();
            } else if (name == 2) {
                this.getDiyList();
            }
        },
        goDel(index, row) {
            if (index == 0 && this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            let that = this;
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 0) {
                        var del_id = [];
                        this.delData.forEach((item) => {
                            del_id.push(item.id);
                        });
                        this.del_id = del_id.join(",");
                        batch_delete({ id: this.del_id })
                            .then((res) => {
                                that.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 1) {
                        batch_delete({ id: row.id })
                            .then((res) => {
                                that.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        useTemplate(row) {
            let that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变使用状态吗？",
                onOk: () => {
                    that.formData.template_id = row.id;
                    that.itemData.template_title = row.title;
                    this.template_modal = false;
                },
                onCancel: () => {},
            });
        },
        goModal(index, row) {
            if (index == 1) {
                if (row) {
                    this.modalTitle = "编辑批次";
                    this.modalWidth = 600;
                    this.infoId = row.id;
                    this.getInfo();
                } else {
                    this.modalTitle = "新增批次";
                    this.modalWidth = 600;
                    this.infoId = "";
                    this.formData.id = "";
                    this.formData.batch_name = "";
                    this.formData.is_voice = 2;
                    this.formData.max_query = "";
                    this.formData.template_type = "1";
                    this.formData.template_id = "";
                    this.formData.is_follow_wechat = 0;
                }
                setTimeout(() => {
                    this.modals = true;
                }, 500);
            } else if (index == 2) {
                if (this.formData.template_type == 1) {
                    this.getTemplateList();
                } else if (this.formData.template_type == 2) {
                    this.getDiyList();
                }
                setTimeout(() => {
                    this.template_modal = true;
                }, 300);
            }
        },
        cancelModal() {
            this.modals = false;
        },
        // 确定
        submitModal() {
            if (!this.formData.batch_name) {
                this.$Message.error("请输入批次名称");
                return;
            }
            batch_save(this.formData)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // selection
        changeSelection(e) {
            this.delData = e;
            if (this.dataTable.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
        goMyCode(row) {
            this.is_code = true;
            this.drawerTitle = "溯源码";
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.page_div {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
::v-deep .ivu-menu.ivu-menu-light.ivu-menu-horizontal {
    display: flex;
    align-items: center;
    justify-content: space-around;
}
::v-deep .ivu-menu-item {
    font-size: 16px;
}
::v-deep .ivu-menu-item:hover {
    font-size: 16px;
    color: #ff761d !important;
    border-bottom: 2px solid #ff761d !important;
}
::v-deep .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    font-size: 16px;
    color: #ff761d;
    border-bottom: 2px solid #ff761d !important;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.width_54 {
    width: 54px;
}
.form-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #9fa5bb;
    border-radius: 5px;
    cursor: pointer;
}
.form-img {
    width: 78px;
    height: 78px;
    border-radius: 5px;
}
.attr_content ::v-deep .ivu-form-item {
    margin-bottom: 0 !important;
}
.form_upload {
    width: 70px;
    height: 70px;
    background: #ffffff;
    border-radius: 5px;
    border: 1px dashed #9fa5bb;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dragg_div {
    display: flex;
    flex-wrap: wrap;
}
.form_icon {
    position: absolute;
    top: -10px;
    right: -10px;
    pointer-events: auto !important; /* 确保可点击 */
}
.width_height_100 {
    width: 100%;
    height: 100%;
}
.position_relative {
    position: relative;
}
.width_100 {
    width: 100%;
}
</style>